// SummaryCards.js
import React from 'react';

const SummaryCards = ({ semesterSummaries, cumulativeSummary }) => {
  return (
    <div className="md:flex gap-5">
      {/* Semester Summaries Table */}
      <div className="overflow-x-auto bg-white mb-6 overflow-hidden rounded-lg shadow-md md:w-1/2 border border-gray-200">
        <table className="min-w-full">
          <thead className="bg-gradient-to-r from-[#0d4f5c] to-[#1a7a8a] text-white">
            <tr className="h-8">
              <th className="px-2 py-0 text-center text-xs font-semibold uppercase leading-4">Part</th>
              <th className="px-2 py-0 text-center text-xs font-semibold uppercase leading-4">SGPA</th>
              <th className="px-2 py-0 text-center text-xs font-semibold uppercase leading-4">Grade Point</th>
              <th className="px-2 py-0 text-center text-xs font-semibold uppercase leading-4">Grade</th>
              <th className="px-2 py-0 text-center text-xs font-semibold uppercase leading-4">Credits</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {semesterSummaries.map((summary, index) => (
              <tr key={index} className="hover:bg-[#0d4f5c]/5 transition-colors duration-150">
                <td className="px-2 py-2 text-sm text-center text-gray-900 font-medium">{summary.part}</td>
                <td className="px-2 py-2 text-center text-sm text-gray-900">{summary.sgpa}</td>
                <td className="px-2 py-2 text-center text-sm text-gray-900">
                  <span className={`inline-block w-16 text-center py-1 rounded-full bg-opacity-20 ${
                    summary.sgpa >= 8.0 ? "bg-green-500 text-green-700" :
                    summary.sgpa >= 6.5 ? "bg-blue-500 text-blue-700" :
                    summary.sgpa >= 5.0 ? "bg-yellow-500 text-yellow-700" :
                    "bg-red-500 text-red-700"
                  }`}>
                    {summary.sgpa}
                  </span>
                </td>
                <td className="px-2 py-2 text-center text-sm text-gray-900">{summary.sGrade}</td>
                <td className="px-2 py-2 text-center text-sm text-gray-900 font-medium">{summary.semesterCreditsEarned}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Cumulative Summary Table */}
      <div className="mb-6 overflow-hidden rounded-lg shadow-md md:w-1/2 border border-gray-200">
        <table className="min-w-full">
          <thead className="bg-gradient-to-r from-[#0d4f5c] to-[#1a7a8a] text-white">
            <tr className="h-8">
              <th className="px-2 py-0 text-center text-xs font-semibold uppercase leading-4">Part</th>
              <th className="px-2 py-0 text-center text-xs font-semibold uppercase leading-4">CGPA</th>
              <th className="px-2 py-0 text-center text-xs font-semibold uppercase leading-4">Grade Point</th>
              <th className="px-2 py-0 text-center text-xs font-semibold uppercase leading-4">Grade</th>
              <th className="px-2 py-0 text-center text-xs font-semibold uppercase leading-4">Credits</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            <tr className="bg-gradient-to-r from-[#0d4f5c]/5 to-[#1a7a8a]/5 hover:bg-[#0d4f5c]/10 transition-colors duration-150">
              <td className="px-2 py-2 text-sm text-center text-gray-900 font-bold">{cumulativeSummary?.part}</td>
              <td className="px-2 py-2 text-center text-sm text-gray-900 font-bold">{cumulativeSummary?.cgpa?.toFixed(2)}</td>
              <td className="px-2 py-2 text-center text-sm text-gray-900">
                <span className={`inline-block w-16 text-center py-1 rounded-full bg-opacity-20 font-bold ${
                  cumulativeSummary?.cgpa >= 8.0 ? "bg-green-500 text-green-700" :
                  cumulativeSummary?.cgpa >= 6.5 ? "bg-blue-500 text-blue-700" :
                  cumulativeSummary?.cgpa >= 5.0 ? "bg-yellow-500 text-yellow-700" :
                  "bg-red-500 text-red-700"
                }`}>
                  {cumulativeSummary?.cgpa?.toFixed(2)}
                </span>
              </td>
              <td className="px-2 py-2 text-center text-sm text-gray-900 font-bold">{cumulativeSummary?.cGrade}</td>
              <td className="px-2 py-2 text-center text-sm text-gray-900 font-bold">{cumulativeSummary?.cumulativeCreditsEarned}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SummaryCards;